<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Research Model</h2>
      <p class="text-sm text-gray-500">Step-based explanation of the foundation's research approach.</p>
    </header>

    <div class="grid grid-cols-2 gap-4">
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Eyebrow</label>
        <input
          v-model="content.eyebrow"
          type="text"
          maxlength="120"
          class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
          placeholder="Our Research Model"
        >
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-700">Headline</label>
        <input
          v-model="content.headline"
          type="text"
          maxlength="250"
          class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
          placeholder="Flipping the Script on Research"
        >
      </div>
    </div>

    <div>
      <label class="mb-2 block text-sm font-medium text-gray-700">Steps</label>
      <TemplateRepeatableList
        v-model="content.steps"
        :max-items="6"
        :new-item="newStep"
        item-noun="step"
      >
        <template #item="{ item, index }">
          <div class="space-y-2">
            <input
              v-model="item.title"
              type="text"
              maxlength="120"
              :placeholder="`Step ${index + 1} title`"
              class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
            >
            <textarea
              v-model="item.body"
              rows="2"
              maxlength="1000"
              placeholder="Step body"
              class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
            />
            <input
              v-model="item.icon"
              type="text"
              maxlength="120"
              placeholder="Icon identifier (fa-beaker) or image path"
              class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
            >
          </div>
        </template>
      </TemplateRepeatableList>
    </div>
  </section>
</template>

<script>
import TemplateRepeatableList from '../TemplateRepeatableList.vue';

export default {
  name: 'ResearchModelSectionEditor',
  components: { TemplateRepeatableList },
  props: {
    content: { type: Object, required: true },
  },
  methods: {
    newStep() {
      return { title: '', body: '', icon: '' };
    },
  },
};
</script>
